import React, { Component } from 'react';
import QuickSearchResult from './QuickSearchResult';
import { translate } from '../Services/translation';
import { query as queryFunction, setSearchQuery, handleKeyDown, displayResult, setProductSearchQuery, displayProductResult } from '../Actions/QuickSearch.action';
import { connect } from "react-redux";
import * as debounce from 'lodash.debounce';
import { useSelector, useDispatch } from 'react-redux';
import ProductQuickSearchResult from './ProductQuickSearchResult';



const QuickSearch = (props) => {    
    const dispatch = useDispatch();

    const onKeyDown = (event, opt) => {
        dispatch(handleKeyDown(event, opt));
    }

    const onClose = () => {
        dispatch(displayResult(false));
        dispatch(displayProductResult(false));
    }

    const focusOnInput = () => {
        setTimeout(() => {
            this.searchInput && this.searchInput.focus();
        }, 0);
    }
    const onBlur = () => {
        /*const { showResult, onClose } = this.props;
        if (this.searchContainer && !this.searchContainer.contains(this.lastClickedNode)) {
            showResult && onClose();
        }*/
    }

    const debouncedQuery = debounce((dispatch, text) => dispatch(queryFunction(text, props ? props.OnlyProducts : false)), 200);

    const onSearch = (text) => {
        dispatch(props.OnlyProducts ? setProductSearchQuery(text) : setSearchQuery(text));        
        debouncedQuery(dispatch, text);
    }
        
        const KEY_CODE_ENTER = 13;
        const keyCode = KEY_CODE_ENTER;        

        const { 
            result,
            showResult,
            selectedItem,
            query,
            error,
            showProductSearchResult,
            productQuery 
        } = useSelector((state) => state.quickSearch);

        const searchUrl = query ? window.__litium.quickSearchUrl + (query.length > 0 ? `?q=${query}` : '') : "";                     
        const searchUrlProduct = productQuery ? window.__litium.quickSearchUrl + (productQuery.length > 0 ? `?q=${productQuery}&onlyProducts=${true}` : '') : "";
       
        const handleSearch = () => {
            const searchUrl = props.OnlyProducts ? searchUrlProduct : searchUrl;
            onKeyDown({ keyCode: KEY_CODE_ENTER }, { searchUrl });
        };

        return (
            <div className="quick-search" role="search">
                <div className={`quick-search__form quick-search__form--force-show ${query ? 'quick-search__not-empty' : ''}`} role="search">
                    <input className="quick-search__input" type="search" placeholder={props && props.OnlyProducts ? translate("coptikk.product.search")
                    : translate("coptikk.general.search")}
                        autoComplete="off" value={error ? "" : (props.OnlyProducts ? productQuery : query)} onChange={event => onSearch(event.target.value)}
                        onKeyDown={event => onKeyDown(event, props.OnlyProducts ? {searchUrl: searchUrlProduct} : {searchUrl})} /*ref={(input) => { this.searchInput = input; }}*/
                        onBlur={() => onBlur()} />
                    {!props.OnlyProducts && query ? <i className="quick-search__icon-close" onClick={() => onSearch("")}></i> : undefined}
                    {props.OnlyProducts && productQuery ? <i className="quick-search__icon-close" onClick={() => onSearch("")}></i> : undefined}
                    <i className="quick-search__icon" onClick={handleSearch}></i>
                    {props && props.OnlyProducts && showProductSearchResult
                    && <ProductQuickSearchResult result={result} selectedItem={selectedItem} searchUrl={searchUrlProduct} 
                    query={productQuery} 
                    onClose={onClose} onlyProducts={props.OnlyProducts}></ProductQuickSearchResult>} 
                    {!props.OnlyProducts && showResult && 
                    <QuickSearchResult result={result} selectedItem={selectedItem} searchUrl={searchUrl} 
                    query={query} 
                    onClose={onClose} onlyProducts={props.OnlyProducts}/>}
                </div>
            </div>
        )    
    
}

export default QuickSearch;